import { useEffect, useRef, useState } from "react";
import "./NewPreviewUI.css";
import moment from "moment";
import { useDispatch } from "react-redux";

import { Skeleton } from "@mui/material";
import { setpreviewObject } from "../../redux/slices/Preview";

const NewPreviewSmallCard = ({
  useTemplateSelected,
  data,
  selected,
  index,
  onSelect,
}) => {
  const meetingObject = localStorage.getItem("meetingObject");

  const meetingData = JSON.parse(meetingObject);
  const [video, setVideo] = useState(false);
  const videoRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const dispatch = useDispatch();
  const gradient = `linear-gradient(to top, ${data?.primaryColor} 10%, #21211E 100%)`;

  useEffect(() => {
    if (!useTemplateSelected) {
      if (videoRef.current) {
        videoRef.current.play();
      }
    }
  }, [videoRef]);

  useEffect(() => {
    if (!useTemplateSelected) {
      if (selected) {
        const meetingDetails = JSON.parse(
          localStorage.getItem("MeetingObject")
        );
      }
    } else {
      const meetingDetails = JSON.parse(localStorage.getItem("MeetingObject"));
      data.arguments.event_name = meetingDetails.name;
      //   data.arguments.date = formatDate(meetingDetails.startTime);
      data.arguments.roomId = meetingDetails.roomId;
    }
  }, []);

  useEffect(() => {
    if (!useTemplateSelected) {
      if (data) {
        if (
          data.imageUrl.toLowerCase().includes(".mp4") ||
          data.imageUrl.toLowerCase().includes(".mov") ||
          data.imageUrl.toLowerCase().includes(".avi")
        ) {
          setVideo(true);
        }
      }
      const meetingDetails = JSON.parse(localStorage.getItem("MeetingObject"));
      //setMeetingData(meetingDetails);
    }
  }, [data]);

  const handleClick = () => {
    if (!useTemplateSelected) {
      onSelect(index);

      dispatch(
        setpreviewObject({
          ...data,

          selectedIndex: index,
          showTitle: true,
        })
      );
    } else {
      onSelect(index);

      const meetingDetails = JSON.parse(localStorage.getItem("MeetingObject"));
      const newData = { ...data, arguments: { ...data.arguments } };

      newData.arguments.event_name = meetingDetails.name;
      //   newData.arguments.date = formatDate(meetingDetails.startTime);
      newData.arguments.roomId = meetingDetails.roomId;

      // dispatch(setpreviewTemplateObject(newData));
    }
  };

  return useTemplateSelected ? (
    <div
      onClick={handleClick}
      style={{
        backgroundImage: gradient,
        height: "20vh",
        width: "95%",
        objectFit: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "2vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {selected && (
        <div
          className="tick-mark"
          style={{
            position: "absolute",
            top: "0px",
            left: "50px",
            color: "white",
            fontSize: "3vh",
            zIndex: 1,
          }}
        >
          ✔
        </div>
      )}

      <iframe
        title={`template-${index}`}
        // srcDoc={renderedHtml}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "640px",
          height: "480px",
          transform: "translate(-50%, -50%) scale(0.24)",
          border: selected ? "10px solid green" : "none",
          pointerEvents: "none",
          overflow: "hidden",
        }}
      />
    </div>
  ) : (
    <div
      className={`singlepreviewcard ${selected ? "selected" : ""}`}
      onClick={handleClick}
      style={{
        backgroundImage: gradient,
        height: "20vh",
        width: "95%",
        objectFit: "cover",
        marginBottom: "2vh",
        border: selected ? "3px solid green" : "none",
        position: "relative",
      }}
    >
      {selected && (
        <div
          className="tick-mark"
          style={{
            position: "absolute",
            top: "0px",
            left: "0px",
            color: "white",
            fontSize: "3vh",
            zIndex: 1,
          }}
        >
          ✔
        </div>
      )}

      {video ? (
        <div style={{ width: "100%", borderRadius: "2vw" }}>
          <video
            ref={videoRef}
            className="fullscreen-video"
            src={data?.imageUrl}
            autoPlay
            muted
            loop
          />
        </div>
      ) : (
        <>
          {!imageLoaded && (
            <Skeleton
              variant="rounded"
              width="100%"
              height="100%"
              sx={{ bgcolor: "grey.500" }}
            />
          )}
          <img
            src={data?.imageUrl}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              display: imageLoaded ? "block" : "none",
            }}
            onLoad={() => setImageLoaded(true)}
            alt="Preview"
          />
        </>
      )}

      <div
        className="contentWrapper"
        style={{
          position: "absolute",
          top: "5%",
          left: "5%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          color: `${data?.fontColor || ""}`,
        }}
      >
        <span
          className="contentWrapperMeetingName"
          style={{ fontFamily: `${data.fontStyle}`, fontSize: "3vh" }}
        >
          {meetingData?.name || "Event Name"}
        </span>
        <span className="contentWrapperMeetingNameTime">
          By {meetingData?.user || "John Doe"}
        </span>
      </div>
    </div>
  );
};

export default NewPreviewSmallCard;
